import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';
import {
  Badge,
  Box,
  Button,
  Flex,
  IconButton,
  InputGroup,
  Text,
  useDisclosure,
} from '@chakra-ui/react';
import { USERS_LISTING_API, TEAM_MEMBERS_API } from 'constants/endpoints';
import useApi from 'hooks/useApi';
import { userColumns } from 'views/admin/users/variables';
import {
  ROLE_DROPDOWN_DATA,
  PLATFORM_DROPDOWN_DATA,
  LIMIT_EXHAUSTED_OPTIONS,
  ONBOARDING_DROPDOWN_DATA,
  EMAIL_TYPE_FILTER_OPTIONS
} from 'constants/filterDropdownData';
import Pagination from 'components/pagination/Pagination';
import ErrorDisplay from 'components/errorDisplay/ErrorDisplay';
import { formatUsersTableData } from 'utils/common';
import {
  UPDATE_USER_AND_PROPERTY_API,
  GET_USER_API_FN,
} from 'constants/endpoints';
import { showToast } from 'components/toast/Toast';
import { OverlayLoaderComponent } from 'components/loader/Loader';
import SidebarFilter from 'components/sidebarFilter/SidebarFilter';
import { ENTITY_FILTER_TYPES } from 'utils/common';
import { getFilterFromLocalStorage } from 'utils/common';
import { setFilterToLocalStorage } from 'utils/common';
import { SearchBar } from 'components/navbar/searchBar/SearchBar';
import ManageColumns from 'components/manageColumns/ManageColumns';
import NoDataFound from 'components/noDataFound/NoDataFound';
import { SORT_DIRECTIONS } from 'constants/filterDropdownData';
import { ENTITY_COLUMNS_TYPES } from 'utils/common';
import { FiChevronsDown, FiFilter } from 'react-icons/fi';
import CustomTable from 'components/table/CustomTable';
import { formatDateToDDMMYYYY } from 'utils/common';
import SignupFormModal from 'components/form/Signup';
import { PHONE_VERIFIED_DROPDOWN_DATA } from 'constants/filterDropdownData';
import { USER_STATUS } from 'constants/filterDropdownData';
import Menu from 'components/menu/MainMenu';
import UserRequirementModal from './components/modal/UserRequirementModal';
import { USER_REQUIREMENT_ACTIONS } from 'constants/defaultState';
import { DownloadIcon } from '@chakra-ui/icons';
import DownloadUsersModal from './components/modal/DownloadUsers/DownloadUsersModal';
import { UPDATE_USER_COMMENT } from 'constants/endpoints';
import JSONModal from './components/modal/JSONModal';
import { GET_CLASSIFIED_USER } from 'constants/endpoints';
import ShareToWhatsapp from './components/modal/ShareToWhatsapp';
import { ADMIN_VERIFICATION_STATUS } from 'constants/filterDropdownData';
import VisibilityModal from './components/modal/VisibilityModal';
import { CLASSIFIED_ROLE_TYPES } from 'constants/filterDropdownData';
import { GENDER_FILTER_DROPDOWN_DATA } from 'constants/filterDropdownData';
import { ReferrerTypes } from 'constants/filterDropdownData';
import { ENABLE_LEAD_AUTOMATION_OPTIONS } from 'constants/filterDropdownData';

const PAGE_SIZE = 50;
const today = new Date();
const thirtyDaysAgo = new Date();
thirtyDaysAgo.setDate(today.getDate() - 30);


export default function Users() {
  const { apiCall, loading } = useApi();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [isOpenFilterSidebar, setIsOpenFilterSidebar] = useState(false);
  const [openLoginForm, setOpenLoginForm] = useState(false);
  const [userData, setUserData] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [openRequirementForm, setOpenRequirementForm] = useState(false);
  const [apiError, setApiError] = useState(null);
  const [openDownloadUsersModal, setOpenDownloadUsersModal] = useState(false);
  const [isVisibilityModalOpen, setIsVisibilityModalOpen] = useState(false);
  const [userModalType, setUserModalType]= useState('')

  const { isOpen : isJsonModalOpen, onOpen: openJsonModal, onClose: closeJsonModal } = useDisclosure();
  const [currentUserInfo,setCurrentUserInfo]=useState(null)

  const lsFiltersUsersPageSize = getFilterFromLocalStorage(
    ENTITY_FILTER_TYPES.USERS_PAGE_SIZE
  );
  const [pageSize, setPageSize] = useState(
    lsFiltersUsersPageSize ? lsFiltersUsersPageSize : PAGE_SIZE
  );
  const lsFilters = getFilterFromLocalStorage(ENTITY_FILTER_TYPES.USERS_FILTER);
  const initialFIlterData = {
    role: '',
    onboardingCompleted: '',
    emailType: '',
    phoneVerified: '',
    platform: '',
    sortType: 'created_at',
    sortDirection: 'descending',
    admin_verified:'',
    dateRange: {
      startDate: thirtyDaysAgo,
      endDate: today
    },
    contactViewLimitExhausted:'',
    postingLimitExhausted:'',
    classified_primary_role:[],
    gender: '',
    referrer:'',
    enable_lead_automation: "",
    commented_by: ""
  };
  const [filters, setFilters] = useState(
    lsFilters ? {...initialFIlterData, ...lsFilters} : { ...initialFIlterData }
  );
  const {
    role = "",
    onboardingCompleted = "",
    emailType = "",
    phoneVerified = "",
    platform = "",
    sortType = "",
    sortDirection = "",
    admin_verified='',
    dateRange,
    contactViewLimitExhausted='',
    postingLimitExhausted='',
    classified_primary_role = [],
    referrer= '',
    gender = '',
    enable_lead_automation = "",
    commented_by = ""
  } = filters || {};
  const [filteredData, setFilteredData] = useState(
    lsFilters ? Object.keys(lsFilters).filter((item) => filters[item]) : []
  );
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(10);
  const [filterRemoveFlagCount, setFilterRemoveFlagCount] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [jsonData, setJsonData] = useState([]);
  const [selectedRowsData, setSelectedRowsData] = useState([]);
  const { search } = useLocation();
  const queryObject = Object.fromEntries(new URLSearchParams(search));
  const [manageColumnSelectḀ̥̥̥̥̥̥̥̥llCheckbox, setManageColumnSelectAllCheckbox] = useState(false);
  const [selectedAction, setSelectedAction] = useState('');
  const [currentIndex,setCurrentIndex]=useState(null);
  const [selectedUser, setSelectedUser] = useState({});
  const [isShareToWhatsappOpen,setIsShareToWhatsappOpen]=useState(false)
  const [teamMembers, setTeamMembers] = useState([]);

  const startDate = dateRange?.startDate || "";
  const endDate = dateRange?.endDate || "";

  const fetchData = useCallback(
    async (text) => {
      try {
        const data = await apiCall.get(`${USERS_LISTING_API}`, {
          role,
          onboarding_completed: onboardingCompleted,
          email_type: filters?.emailType,
          phone_verified: filters?.phoneVerified,
          ...(!!admin_verified ? {admin_verified:filters.admin_verified}: {}),
          platform,
          search_text: text,
          page: currentPage,
          limit: pageSize,
          sort_by: sortType,
          sort_order: sortDirection,
          start_date: formatDateToDDMMYYYY(startDate),
          end_date: formatDateToDDMMYYYY(endDate),
          posting_limit_exhausted: postingLimitExhausted,
          contact_view_limit_exhausted:contactViewLimitExhausted,
          classified_primary_role: classified_primary_role?.join?.(','),
          gender,
          referrer,
          enable_lead_automation,
          commented_by
        });
        const formatData = data?.data?.users.reverse();
        setTotalPages(Math.ceil(data?.data?.count / pageSize));
        setTotalCount(data?.data?.count);
        setUserData(formatData);
      } catch (error) {
        console.log(error);
        setApiError(error);
      }
    },
    [
      role,
      onboardingCompleted,
      emailType,
      phoneVerified,
      admin_verified,
      platform,
      searchText,
      currentPage,
      pageSize,
      sortType,
      sortDirection,
      startDate,
      endDate,
      postingLimitExhausted,
      contactViewLimitExhausted,
      classified_primary_role,
      gender,
      referrer,
      enable_lead_automation,
      commented_by
    ]
  );

  useEffect(() => {
    (async () => {
      try {
        const res = await apiCall.get(TEAM_MEMBERS_API);
        const list = Array.isArray(res?.data) ? res.data : (res?.data?.data || []);
        setTeamMembers(list);
      } catch (err) {
        console.log('team-members fetch failed', err);
      }
    })();
  }, []);

  const commentedByOptions = useMemo(
    () =>
      teamMembers.map((m) => ({
        label: `${m.first_name || ''} ${m.last_name || ''}`.trim() + (m.role ? ` — ${m.role}` : ''),
        value: m._id,
      })),
    [teamMembers]
  );

  useEffect(() => {
    if (queryObject?.search_text) {
      setSearchText(queryObject?.search_text);
      handleFetchSearch(queryObject?.search_text);
    } else {
      setSearchText('')
      fetchData();
      setFilterToLocalStorage(ENTITY_FILTER_TYPES.USERS_FILTER, filters);
    }
  }, [filterRemoveFlagCount, currentPage, queryObject?.search_text, pageSize]);

  const handleFilterChange = useCallback((key, value) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      [key]: value,
    }));
    setCurrentPage(1);
  }, []);

  const toggleSidebar = () => {
    setIsOpenFilterSidebar(!isOpenFilterSidebar);
  };

  const handleApplyFilter = () => {
    const applyFilterArray = filters
      ? Object.keys(filters).filter((key) => filters[key])
      : [];
    setFilteredData(applyFilterArray);
    setFilterToLocalStorage(ENTITY_FILTER_TYPES.USERS_FILTER, filters);
    setCurrentPage(1);
    fetchData();
  };

  const handleRemoveAllFilter = () => {
    setFilteredData([]);
    setFilters({ ...initialFIlterData, emailType: '', phoneVerified: '', admin_verified:'', dateRange: {startDate: "", endDate: ""} });
  };

  const onPhoneNumberClick = async (phone) => {
    try {
      const user = userData.find((user) => user.phone === phone);
      const data = await apiCall.get(GET_USER_API_FN(user._id));
      setJsonData(data?.data);
    } catch (error) {
      console.log(error);
    }
  };

  const handleUpdateUser = async ({ id, data }) => {
    try {
      await apiCall.patch(UPDATE_USER_AND_PROPERTY_API, {
        updateData: [
          {
            type: 'users',
            _id: id,
            data,
          },
        ],
      });
      showToast({
        message: 'User updated successfully',
        customStyle: {
          background: 'green',
          color: '#fff',
          padding: '10px',
        },
      });
      onClose();
    } catch (error) {
      console.log(error);
    }
  };

  const dropdownFilters = [
    {
      name: 'role',
      data: ROLE_DROPDOWN_DATA,
      placeholder: 'Select Role',
      value: role,
    },
    {
      name: 'onboardingCompleted',
      data: ONBOARDING_DROPDOWN_DATA,
      placeholder: 'Select Onboarding Status',
      value: onboardingCompleted,
    },
    {
      name: 'emailType',
      data: EMAIL_TYPE_FILTER_OPTIONS,
      placeholder: 'Select Email Type Status',
      value: emailType,
    },
    {
      name: 'phoneVerified',
      data: PHONE_VERIFIED_DROPDOWN_DATA,
      placeholder: 'Select phone Verified Status',
      value: phoneVerified,
    },
    {
      name: 'admin_verified',
      data: ADMIN_VERIFICATION_STATUS,
      placeholder: 'Select Admin verified',
      value: admin_verified,
    },
    {
      name: 'platform',
      data: PLATFORM_DROPDOWN_DATA,
      placeholder: 'Select Platform',
      value: platform,
    },
    {
      name: 'referrer',
      data: ReferrerTypes,
      placeholder: 'Referrer',
      value: referrer,
    },
    {
      name: 'classified_primary_role',
      data: CLASSIFIED_ROLE_TYPES.map(role => ({ label: role.charAt(0).toUpperCase() + role.slice(1), value: role })),
      placeholder: 'Select Primary Role',
      value: classified_primary_role,
    },
    {
      name: 'gender',
      data: GENDER_FILTER_DROPDOWN_DATA,
      placeholder: 'Select Gender',
      value: gender,
    },
    {
      name: 'contactViewLimitExhausted',
      data: LIMIT_EXHAUSTED_OPTIONS,
      placeholder: 'Select Contact Limit Status',
      value: contactViewLimitExhausted,
    },
    {
      name: 'postingLimitExhausted',
      data: LIMIT_EXHAUSTED_OPTIONS,
      placeholder: 'Select Posting Limit Status',
      value: postingLimitExhausted,
    },
    {
      name: 'enable_lead_automation',
      data: ENABLE_LEAD_AUTOMATION_OPTIONS,
      placeholder: 'Lead Automation Status',
      value: enable_lead_automation,
    },
    {
      name: 'commented_by',
      data: commentedByOptions,
      placeholder: 'Commented By',
      value: commented_by,
    },
  ];

  const SORT_TYPES = [
    {
      label: 'Created At',
      value: 'created_at',
    },
    {
      label: 'Total Properties',
      value: 'total_properties',
    },
  ];

  const dropdownSorts = [
    {
      name: 'sortType',
      placeholder: '',
      value: sortType,
      data: SORT_TYPES,
    },
    {
      name: 'sortDirection',
      placeholder: '',
      value: sortDirection,
      data: SORT_DIRECTIONS,
    },
  ];

  const allFiltersProps = {
    dropdowns: dropdownFilters,
    sorts: dropdownSorts,
  };


  const onClassifiedClick=useCallback((rowData)=>{
    setSelectedAction(rowData);
    const {_id, comment, platform} = rowData || {}
    setCurrentIndex(userData?.findIndex((item) => item?._id === _id))
    setCurrentUserInfo({
      id: _id,
      comment,
      platform
    });
    openJsonModal();
  },[userData])

  const generateUserClassification = async (id) => {
    try {
      const res= await apiCall.post(`${GET_CLASSIFIED_USER}`, {
        userId: id
      });

      if (res?.data?.success === false) {
        throw new Error(res?.data?.error);
      } else {
        fetchData();
        showToast({
          message: "User Classification Updated",
          success: true,
          customStyle: {
            background: "#52c41a",
            color: "#fff",
            padding: "10px",
          },
        })
      }
    } catch (error) {
      showToast({
        message: error?.message ?? "Failed to update user classification",
        success: false,
        customStyle: {
          background: "#ff4d4f",
          color: "#fff",
          padding: "10px",
        },
      }) 
    }
  }

  const columns = useMemo(() => userColumns(onClassifiedClick), [userColumns, onClassifiedClick]);
  const data = useMemo(() => formatUsersTableData(userData), [userData]);

  const lsLocalStorageManageColumns = getFilterFromLocalStorage(
    ENTITY_COLUMNS_TYPES.USERS_COLUMNS
  );

  const [columnVisibility, setColumnVisibility] = useState(
    lsLocalStorageManageColumns
      ? lsLocalStorageManageColumns
      : columns.reduce((acc, column) => {
          acc[column.accessor] = true;
          return acc;
        }, {})
  );

  const handleColumnChange = (accessor) => {
    setColumnVisibility((prev) => ({
      ...prev,
      [accessor]: !prev[accessor],
    }));
  };

  useEffect(() => {
    setFilterToLocalStorage(
      ENTITY_COLUMNS_TYPES.USERS_COLUMNS,
      columnVisibility
    );
  }, [columnVisibility]);

  const visibleColumns = columns.filter(
    (column) => columnVisibility[column.accessor]
  );

  const handleFetchSearch = useCallback(
    (text) => {
      setCurrentPage(1);
      fetchData(text);
    },
    [fetchData]
  );

  const handleInputFormSubmit = (e) => {
    e.preventDefault();
    handleFetchSearch(searchText);
  };

  const currentuserInfo=useMemo(()=>{
    return userData.find(item=>item._id === selectedAction._id)

  },[userData, selectedAction])

  const handleRowSelect = useCallback(
    (row) => {
      const findData = selectedRowsData.find(
        (item) => item.phone === row.phone
      );
      setSelectedRowsData((prev) => {
        if (findData) {
          return prev.filter((item) => item.phone !== findData.phone);
        } else {
          return [...prev, row];
        }
      });
    },
    [setSelectedRowsData, selectedRowsData]
  );

  if (apiError) {
    return <ErrorDisplay error={apiError} />;
  }

  const handleUserAction = async ({
    updatedPropertyType,
    id: selectedId,
    comment,
    status
  }) => {
    try {
      if(status === "Add Comment"){
        if(comment === selectedAction.comment) return;
        const payload = {
          user_id: selectedId,
          comment
        }
        await apiCall.post(UPDATE_USER_COMMENT, payload)
        return fetchData()
      }
      if(updatedPropertyType==='Share To Whatsapp'){
        setIsShareToWhatsappOpen(true);
        return;
      }

      if(status === "Update Classification"){
       generateUserClassification(selectedId)
       return;
      }
      const data = userData.find((item) => item?._id === selectedId);
      const { first_name, last_name, role, _id, phone, email, number_private, gender, enable_lead_automation } = data;
      if(updatedPropertyType ==="Change Number Visibility"){
        setUserModalType(updatedPropertyType);
        setSelectedUser({ first_name, last_name, _id, number_private })
        setIsVisibilityModalOpen(true);
        return;
      }
      if(updatedPropertyType ==="Change Lead Automation"){
        setUserModalType(updatedPropertyType);
        setSelectedUser({ first_name, last_name, _id, enable_lead_automation  })
        setIsVisibilityModalOpen(true);
        return;
      }
      if(updatedPropertyType === '/admin/form'){
        setOpenLoginForm(true);
        setSelectedUser({ first_name, last_name, role, _id, phone, email, gender })
      }
      if(updatedPropertyType === USER_REQUIREMENT_ACTIONS.ADD_REQUIREMENT){
        setOpenRequirementForm(true);
        setSelectedUser({ first_name, last_name, role, _id, phone, email })
        return;
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleDownloadUsersModal = () => {
    setOpenDownloadUsersModal(true);
  };

  return (
    <>
      <Box height="100vh" bg="#F8FAFB">
      <Flex
        justify="space-between"
        p={{ base: 2, md: 4 }}
        align="center"
        direction={{ base: "column", md: "row" }}
        boxShadow="sm"
        borderRadius="sm"
        pos={{ base: "relative", md: "fixed" }}
        w={{ base: "100%", md: "calc(100vw - 96px)" }}
        zIndex={1000}
        gap={{ base: 3, md: 4 }}
      >
        {/* LEFT SECTION */}
        <Flex
          gap={{ base: 2, md: 4 }}
          w={{ base: 'full', md: "auto" }}
          direction={{ base: "column", md: "row" }}
          p={{ base: 1, md: 2 }}
        >
          <Flex
            gap={{ base: 2, md: 4 }}
            align="center"
            justify={{ base: "end", md: "space-between" }}
            w={{ base: 'full', md: "auto" }}
            wrap="wrap"
          >
            {/* Filter */}
            <Box position="relative">
              <Button
                paddingX={6}
                leftIcon={<FiFilter />}
                rightIcon={<FiChevronsDown />}
                colorScheme="teal"
                variant="outline"
                borderRadius="md"
                size="sm"
                w={{ base: "100%", md: "auto" }}
                onClick={() => {
                  toggleSidebar();
                  setFilters(lsFilters);
                }}
              >
                Filter
              </Button>

              {filteredData?.length > 0 && (
                <Badge
                  position="absolute"
                  top="-2"
                  right="-2"
                  colorScheme="teal"
                  borderRadius="full"
                  px={2}
                  fontSize="0.8em"
                >
                  {filteredData.length}
                </Badge>
              )}
            </Box>

            <ManageColumns
              columns={columns}
              handleColumnChange={handleColumnChange}
              columnVisibility={columnVisibility}
              setManageColumnSelectAllCheckbox={setManageColumnSelectAllCheckbox}
              manageColumnSelectḀ̥̥̥̥̥̥̥̥llCheckbox={
                manageColumnSelectḀ̥̥̥̥̥̥̥̥llCheckbox
              }
            />

            {/* Mobile download */}
            <IconButton
              icon={<DownloadIcon />}
              aria-label="Download"
              onClick={handleDownloadUsersModal}
              boxSize="40px"
              display={{ base: "flex", md: "none" }}
            />
          </Flex>

          {/* Search */}
          <form onSubmit={handleInputFormSubmit}>
            <InputGroup size="sm">
              <SearchBar
                background="#F9F9FB"
                color="#637381"
                setSearchText={(e) => setSearchText(e.target.value)}
                searchText={searchText}
                borderRadius="5px"
                borderWidth="0.5px"
                borderColor="#637381"
              />
            </InputGroup>
          </form>
        </Flex>

        {/* RIGHT SECTION */}
        <Flex
          gap={{ base: 4, md: 8 }}
          align="center"
          w={{ base: 'full', md: "auto" }}
          justify={{ base: "space-between", md: "flex-start" }}
        >
          <Text
            fontSize="sm"
            borderRadius="5px"
            borderWidth="0.5px"
            borderColor="#637381"
            background="#F9F9FB"
            color="#637381"
            p={1}
            whiteSpace="nowrap"
          >
            Total Users: {totalCount}
          </Text>

          <Button
            borderRadius="5px"
            background="linear-gradient(180deg, #22ACEE 0%, #0177B4 100%)"
            color="#ffffff"
            fontSize="sm"
            w={{ base: "100%", md: "auto" }}
            onClick={() => setOpenLoginForm(true)}
          >
            Create User
          </Button>

          {/* Desktop download */}
          <IconButton
            icon={<DownloadIcon />}
            aria-label="Download"
            onClick={handleDownloadUsersModal}
            boxSize="50px"
            display={{ base: "none", md: "block" }}
          />
        </Flex>

        {/* Pagination */}
        <Flex justify="center" mt={{ base: 2, md: 0 }}>
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={(value) => setCurrentPage(value)}
            totalCount={totalCount}
            setCurrentPage={setCurrentPage}
            pageSize={pageSize}
            setPageSize={setPageSize}
            setPageSizeToLocalStorage={(value) =>
              setFilterToLocalStorage(
                ENTITY_FILTER_TYPES.USERS_PAGE_SIZE,
                value
              )
            }
          />
        </Flex>
      </Flex>

        <SidebarFilter
          filters={allFiltersProps}
          handleFilterChange={handleFilterChange}
          handleApplyFilter={handleApplyFilter}
          isOpen={isOpenFilterSidebar}
          onClose={toggleSidebar}
          appliedFilters={filters}
          lsFilters={lsFilters}
          setFilters={setFilters}
          handleRemoveAllFilter={handleRemoveAllFilter}
          isCalenderFilter={true}
          dateRangeLabel={commented_by ? 'Comment date' : 'Posted on'}
          enableMultiselect
          multiSelectKey={['classified_primary_role']}
        />
        {userData?.length !== 0 ? (
          <>
            <CustomTable
              columns={visibleColumns}
              data={data}
              conditionalStyling={(row) =>
                row?.original?.contact_view_limit_exhausted
                  ? { backgroundColor: '#00ff002b' }
                  : {}
              }
              onPhoneNumberClick={onPhoneNumberClick}
              jsonData={jsonData}
              onOpen={onOpen}
              onClose={onClose}
              isOpen={isOpen}
              onUpdateUser={handleUpdateUser}
              handleRowSelect={handleRowSelect}
              selectedRowsData={selectedRowsData}
              setSelectedRowsData={setSelectedRowsData}
              onSelectedAction={setSelectedAction}
              menuComponent={
                <Menu
                  data={Object.values(USER_STATUS)}
                  onUpdate={() => {}}
                  onUpdatePropertyStatus={handleUserAction}
                  selectedAction={selectedAction}
                  dataType="users"
                  showInput={true}
                />
              }
            />
          </>
        ) : !loading ? (
          <NoDataFound />
        ) : null}
        <OverlayLoaderComponent isOpen={loading} />
      </Box>
      <SignupFormModal
        isOpen={openLoginForm}
        onClose={() => setOpenLoginForm(false)}
        setOpenLoginForm={setOpenLoginForm}
        selectedUser={selectedUser}
        setSelectedUser={setSelectedUser}
        setUserData={setUserData}
      />
      <UserRequirementModal
        isOpen={openRequirementForm}
        onClose={() => setOpenRequirementForm(false)}
        userId={selectedUser?._id}
        selectedData={{ ...selectedAction, full_name: selectedAction.name }}
      />
      <DownloadUsersModal
        isOpen={openDownloadUsersModal}
        onClose={()=> setOpenDownloadUsersModal(false)}
        filters={filters}
      />
      {(currentUserInfo?.id && userData?.length && isJsonModalOpen) ? (
        <JSONModal 
          isOpen={isJsonModalOpen} 
          onClose={closeJsonModal} 
          allData={userData} 
          setCurrentIndex={setCurrentIndex}
          currentIndex={currentIndex}
          refreshTableData={()=>fetchData(searchText)} 
          onEditComment={handleUserAction}
        />
      ) : null}
      {currentuserInfo && isShareToWhatsappOpen && (
        <ShareToWhatsapp
          isOpen={isShareToWhatsappOpen}
          onClose={()=>setIsShareToWhatsappOpen(false)}
          defaultMessageType={'post_property'}
          userData={currentuserInfo}
        />
      )}
      {isVisibilityModalOpen && (
        <VisibilityModal
          userData={selectedUser}
          refetchData={fetchData}
          isOpen={isVisibilityModalOpen} 
          onClose={()=>setIsVisibilityModalOpen(false)} 
          modalType={userModalType}
        />
      )}
    </>
  );
}
